export default __webpack_public_path__ + "static/media/logo-bf.1f0e0520.jpg";